const carousels = () => {

    if ($('.hero-slider').length > 0) {

		$('.hero-slider').on('init', function(event, slick){
		    $('.hero-slider').css({'visibility':'visible'});
		});

        $('.hero-slider').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            mobileFirst: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        arrows: true,
                        adaptiveHeight: false,
                        asNavFor: '.hero-subslider',
                        prevArrow: "<div class='slick-prev'><img src='assets/img/svg/angle-left.svg' alt=''></div>",
                        nextArrow: "<div class='slick-next'><img src='assets/img/svg/angle-right.svg' alt=''></div>",
                    }
                }
            ]
        });

    }

    if ($('.hero-subslider').length > 0) {

		$('.hero-subslider').on('init', function(event, slick){
		    $('.hero-subslider').css({'visibility':'visible'});
		});

        if (!($('.hero-subslider').hasClass("slick-initialized"))) {
            $('.hero-subslider').slick({
                dots: false,
                arrows: false,
                infinite: true,
                centerMode: false,
                speed: 500,
                slidesToShow: 3,
                asNavFor: '.hero-slider',
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2.2,
                            infinite: false
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1.2,
                            infinite: false
                        }
                    }
                ]
            });
        } 
    }

    if ($('.occasions-slider').length > 0) {

        function setSlider() {
            if ($(window).width() < 1280) {
                if (!($('.occasions-slider').hasClass("slick-initialized"))) {
                    $('.occasions-slider').slick({
                        dots: false,
                        arrows: false,
                        infinite: false,
                        speed: 500,
                        slidesToShow: 2.2,
                        asNavFor: '.hero-slider',
                        responsive: [
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: 1.2,
                                }
                            }
                        ]
                    });
                } 
            } else {
                if ($('.occasions-slider').hasClass("slick-initialized")) {
                    $('.occasions-slider').slick("unslick")
                }
            }
        }

        setSlider()

        $(window).resize(function(){
            setSlider()
        })

    }

    

}

module.exports = {
    carousels,
};